import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { FormErrors, PageHeading } from '@hp/ui';
import { useCan, useMe } from '../api/me';
import { usePipelineState } from '../features/pipeline/queries';
import { ErrorAlert } from '../components/error-alert';
import { Spinner } from '../components/ui/icons';
import { ActiveRunStrip } from '../features/pipeline/active-run-strip';
import { ManualControls } from '../features/pipeline/manual-controls';
import { NextStepBanner } from '../features/pipeline/next-step-banner';
import { PipelineViz } from '../features/pipeline/pipeline-viz';
import { TotalsStrip } from '../features/pipeline/totals-strip';

export default function DedupOverview() {
  const { t } = useTranslation(['pipeline', 'common']);
  const me = useMe();
  const location = useLocation();
  const authError = new URLSearchParams(location.search).get('auth_error');
  const loggedIn = !!me.data;
  const can = useCan();
  const pipeline = usePipelineState(loggedIn);

  if (!loggedIn) {
    return (
      <div className="bo-sections">
        <PageHeading title={t('title')} />
        {authError && <FormErrors>{t('signInFailed', { reason: authError })}</FormErrors>}
        {!me.isLoading && <p className="bo-muted">{t('signInPrompt')}</p>}
      </div>
    );
  }

  const state = pipeline.data;

  return (
    <div className="bo-sections">
      <PageHeading title={t('title')} description={t('description')} />
      {authError && <FormErrors>{t('signInFailed', { reason: authError })}</FormErrors>}
      <ErrorAlert error={pipeline.error} />
      {pipeline.isLoading && <Spinner>{t('loadingState')}</Spinner>}
      {state && (
        <>
          <NextStepBanner state={state} can={can} />
          {state.activeRun && <ActiveRunStrip run={state.activeRun} />}
          <PipelineViz state={state} can={can} />
          <TotalsStrip totals={state.totals} />
        </>
      )}
      <ManualControls canRun={can('crm.run_jobs')} />
    </div>
  );
}
